import { useEffect, useMemo } from 'react'
import type { ITextFieldMainAction } from 'shared/ui/TextField'

type ITextFieldAutoWidth = {
  minWidth?: number
  maxWidth?: number
}

export const makeTextFieldAutoWidth: (action?: ITextFieldAutoWidth) => ITextFieldMainAction = (
  action
) => {
  const useAction: ITextFieldMainAction = (control, children) => {
    const element = useMemo(() => document.createElement('span'), [])

    useEffect(() => {
      const input = control.inputRef?.current
      const value = control.value
      const containerRef = control.containerRef?.current

      if (!input) return

      const inputStyles = window.getComputedStyle(input)
      element.style.visibility = 'hidden'
      element.style.whiteSpace = 'pre'
      element.style.overflow = 'visible'
      element.style.font = inputStyles.font
      element.style.padding = inputStyles.padding
      element.style.border = inputStyles.border

      document.body.appendChild(element)

      element.textContent = value ?? ''
      const width = element.offsetWidth + 2
      const minWidth = action?.minWidth || 100
      const maxWidth = action?.maxWidth || containerRef?.offsetWidth || 500
      const finalWidth = Math.max(minWidth, Math.min(width, maxWidth))

      input.style.width = `${finalWidth}px`

      return () => {
        document.body.removeChild(element)
      }
    }, [control.value])

    return children
  }

  return useAction
}
